exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.v-table tbody td {\n  height: 24px;\n}\ntable.v-table thead tr {\n  height: 32px;\n}\ntr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n.unitAlertName {\n  color: #39b54a;\n  font-size: 14px;\n  font-weight: 700;\n}\n.v-table__overflow {\n  height: 100%;\n  overflow-y: auto;\n}\n", ""]);

// exports
